import { LoadingIndicator } from '@bambi/component-library/src/components/LoadingIndicator/LoadingIndicator';

import {
  MomentmBrokerAuthRead,
  usePayersRetrieveQuery,
} from 'src/common/external/bambi-api/bambiApi';

interface PayerCellProps {
  payer: MomentmBrokerAuthRead['payer'];
}
export function PayerCell({ payer }: PayerCellProps) {
  const { data: payerData, isLoading } = usePayersRetrieveQuery({
    id: payer,
  });

  if (isLoading) {
    return <LoadingIndicator />;
  }

  return <div>{payerData?.display_name}</div>;
}
